module.exports = __webpack_public_path__ + "img/qxchuhai2.fa2b7dbc.jpeg";